const DK = {
	"off_send_msg": "Du skal være online for at indsende dette",
	"your_off"	: "Du er offline",
	"your_on"	  : "Du er online igen",
	"mail"			: "E-mail",
	"save_info"		: "Gem oplysninger",
	"pass"			: "Kodeord",
	"repeat_pass"	: "Gentag kodeord",
	"log_out"		: "Log ud",
	"update_location"	: "Opdater lokation",
	"log_in"		: "Log ind",
	"forgot_pass"	: "Glemt kodeord?",
	"new_obs"		: "Ny observation",
	"new_ra"		: "Ny rapport",
	"phone"			: "Telefon",
	"settings"		: "Indstillinger",
	"obs"			: "Observationer",
	"ra"			: "R.A",
	"inbox"			: "Indbakke",
	"no_cam_rights" : "Der kræves tilladdelse til kameraet for at bruge denne funktion.",
	"no_camroll_rights" : "Der kræves tilladdelse til kamera rullen for at bruge denne funktion.",

	"alternative_location": "Alternativ lokation",

	"expired"		: "Mangler godkendelse",
	"not_expired"	: "Godkendt værktøj",
	"new_tool"		: "Nyt værktøj",
	"tools"			: "Værktøj",

	"ra_sheet"		: "Spørgeskema",
	"ra_title"		: "Rapporttitel",
	"customer"		: "Kunde",
	"address"		: "Addresse",
	"create"		: "Opret",
	"today"			: "I dag",
	"older"			: "Ældre",
	"history"		: "Historik",
	"send_copy"		: "Skal der sendes en kopi af rapporten til din mail?",

	"camera_actions_title": "Vedhæft billede",

	"obs_at"		: "Observation ved",
	"department": "Afdeling",
	"date"			: "Dato",
	"time"			: "Tidspunkt",
	"desc_act"		: "Beskriv hændelsen",
	"desc_init_act"	: "Midlertidig iværksatte tiltag",
	"priority"		: "Prioritet",
	"documentation"	: "Dokumentation",
	"report_by"		: "Reporteret af",
	"incident_type"	: "Hændelsestype",
	"incident_rela"	: "Relation til",
	"incident_reas"	: "Årsag",
	"send"			: "Send",
	"back"			: "Tilbage",
	"code"			: "Kode",

	"specify_mail"	: "Angiv mail-addresse til modtagelse af kopi",
	"all_fields"	: "Alle felter skal udfyldes!",
	"wrong_pass_mail": "Forkert brugernavn eller kodeord!",

	"settings_changed": "Dine oplysninger er ændret!",
	"pass_not_alike": "De to kodeord er ikke ens",

	"inbox_empty": "Din indbakke er tom",


	"next"			: "Næste",
	"yes"			: "Ja",
	"no"			: "Nej",
	"add_comment"	: "Tilføj kommentar",
	"hide_comment"	: "Skjul kommentar",
	"sign_date"		: "Skal rapporten signeres med et sluttidspunkt?",
	"alert_1"		: "Forebyg så vi undgår risikoen",
	"alert_2"		: "Forebyg eller skærp opmærksomheden om risici",
	"probability"	: "Sandsynlighed",
	"consequence"	: "Konsekvens",
	"alert_answers"	: "Alle spørgsmål skal besvares!",
	"follow_up"		: "Opfølgning",
	"language"		: "Sprog",
	"update_msg"	: "Der er en opdatering til appen. Vil du opdatere nu?\nBemærk: Ikke færdiggjorte rapporter vil blive mistet.",
	"location_msg"  : "Vil du give appen tilladelse til at bruge din lokation?",

	"kaolisTestEn1": "Skade ID",
	"kaolisTestEn2": "SkadeDato",
	"kaolisTestEn3": "Tidspunkt",
	"kaolisTestEn4": "Busnummer",
	"kaolisTestEn5": "Linje",
	"kaolisTestEn6": "Chaufførnummer",
	"kaolisTestEn7": "Chaufførnavn",
	"kaolisTestEn8": "Bustype",
	"kaolisTestEn9": "Skadetype",
	"kaolisTestEn10": "Skyld",
	"kaolisTestEn11": "Manøvre",
	"kaolisTestEn12": "Vejbaneforhold",
	"kaolisTestEn13": "Lysforhold",
	"kaolisTestEn14": "Skade på bus",
	"kaolisTestEn15": "Skade på modpart",
	"kaolisTestEn16": "Hvad kan gøres for at undgå tilsvarende skade",

	"buddy_check"	: "Buddycheck",
	"selfpump"		: "Selvpump",
	"iras"			: "IRAS",
	"lamelpump"		: "Lamelpumpe",
	"physic_thing"	: "Fysiske forhold",
	"rigg"			: "Tilrigning",
	"participants"	: "Deltagere",
	"approval"		: "Godkendelse",
};
export default DK;


// WEBPACK FOOTER //
// ./src/components/langs/appDK.js